<ng-container *transloco="let t; prefix: 'componentLibrary'">
  <!-- TODO: better description verbiage -->
  <section-header [touched]="ngControl.touched" [valid]="ngControl.valid">{{
    t('chooseAddress')
  }}</section-header>
  <section-error errorName="required" [control]="ngControl.control">{{
    t('optionRequired')
  }}</section-error>
  <section-content>
    <mat-radio-group class="vertical condensed">
      @for (address of addressChoices; track address) {
        <mat-radio-button
          [value]="address"
          (change)="onAddressSelection(address)"
          >
          <div class="ellipsis">
            {{ address.display }}
          </div>
          <small class="radio-caption"> {{ t('parcelNumberText') }} {{ address.apn }} </small>
        </mat-radio-button>
      }
    </mat-radio-group>
  </section-content>
</ng-container>
